/**
 * @unscoped — 오픈소스 라이선스 고지 화면 i18n (oss-notices — 2026-07-10).
 *
 * 고지 본문(`/oss/third-party-notices.txt`)은 각 패키지의 라이선스 원문이므로 번역하지 않는다.
 * 원문을 손대면 라이선스 위반이다. 여기서는 화면 껍데기(제목·안내·오류)만 3개 언어로 제공한다.
 *
 * 정책은 다른 *-i18n 모듈과 동일: fallback chain(lang → en → ko), ko/en/ja 전수 보유는
 * `i18n-completeness.test.ts` 가 src/lib 의 모든 *-i18n.ts 를 source-parse 해 강제한다.
 */

import { getSharedLang, FALLBACK_LANG, type Lang } from './base-i18n';

const MESSAGES: Record<string, Record<Lang, string>> = {
  'oss.title': { ko: '오픈소스 라이선스', en: 'Open Source Licenses', ja: 'オープンソースライセンス' },
  'oss.subtitle': {
    ko: '이 서비스는 아래 오픈소스 소프트웨어를 사용합니다.',
    en: 'This service includes the following open source software.',
    ja: '本サービスは以下のオープンソースソフトウェアを使用しています。',
  },
  'oss.loading': { ko: '고지 문서를 불러오는 중…', en: 'Loading notices…', ja: '通知文書を読み込み中…' },
  'oss.error': {
    ko: '고지 문서를 불러오지 못했습니다.',
    en: 'Could not load the notices.',
    ja: '通知文書を読み込めませんでした。',
  },
  'oss.download': { ko: '텍스트 파일로 보기', en: 'View as text file', ja: 'テキストファイルで見る' },
  'oss.back': { ko: '돌아가기', en: 'Back', ja: '戻る' },
  'oss.link': { ko: '오픈소스 라이선스', en: 'Open source licenses', ja: 'オープンソースライセンス' },
};

export function tOss(key: string): string {
  const entry = MESSAGES[key];
  if (!entry) return key;
  const lang = getSharedLang();
  return entry[lang] || entry.en || entry[FALLBACK_LANG] || key;
}
